import { html, render } from "lit-html";
import { formatRangeToLocale } from "@escapio/shared/l10n/date";
import { travelData, onChangeDates } from "@escapio/portal/state/travelData";
import { translate } from "@escapio/shared/l10n/translate";

export class CalendarView extends HTMLElement {
	constructor() {
		super();
		onChangeDates(this.update.bind(this));
	}

	connectedCallback() {
		this.update();
	}

	render() {
		const { arrival, departure, hasDates } = travelData;
		return hasDates
			? formatRangeToLocale(arrival, departure)
			: html`<span class="calendar-view--placeholder">
					${translate("calendar_view_no_dates_set")}
				</span>`;
	}

	update() {
		render(this.render(), this, { host: this });
	}
}

customElements.define("esc-calendar-view", CalendarView);
